export const Colors = {
  Primary: "#3F51B5",
  Secondary: "#353a40",

  Direto: "#2E7D32",
  Inverso: "#6A1B9A",
  Cet: "#3F51B5",
  Reitoria: "#F57C00",

  DiretoSecondary: "#66BB6A",
  InversoSecondary: "#7B1fA2",
  ReitoriaSecondary: "#FFA726",
  CetSecondary: "#1A237E",

  Danger: "#de3434",

  BusRed: "#b71c1c",
  BusOrange: "#ef6c00",
  BusGreen: "#388e3c",
};

export const GreyPallet = {
  Black: "#000000",
  Light: "#EDEDED",
  Regular: "#919191",

  WhiteGhost: "rgba(255, 255, 255, 0.43)",
  LightGhost: "rgba(0, 0, 0, 0.07)",
  RegularGhost: "rgba(0, 0, 0, 0.43)",

  GreyRange: {
    _100: "#EEEEEE",
    _200: "#CCCCCC",
    _300: "#999999",
    _400: "#666666",
    _500: "#333333",
  },
};

// export const Shadows = {
//   base: "0px 4px 15px rgba(0, 0, 0, 0.25)",
//   md: "0px 2px 7px rgba(0, 0, 0, 0.04), 0px 4px 6px rgba(0, 0, 0, 0.05)",
//   lg: "0px 10px 15px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.05)",
//   xl: "0px 20px 25px rgba(0, 0, 0, 0.1), 0px 10px 10px rgba(0, 0, 0, 0.04)",
//   xl2: "0px 25px 50px rgba(0, 0, 0, 0.25)",
//   inner: "inset 2px 2px 2px rgba(11, 11, 13, 0.1)",
// };

// export const Spacing = {
//   extraSmall: "0.5rem",
//   small: "0.75rem",
//   default: "1rem",
//   large: "1.5rem",
//   extraLarge: "2rem",
//   custom: (remSpacing: number) => `${remSpacing}rem`,
// };

// export const Fonts = {
//   Sizes: {
//     sm: "0.785 rem",
//     base: "1 rem",
//     lg: "1.125 rem",
//     xl: "1.25 rem",
//     xl2: "2 rem",
//     xl3: "2.25 rem",
//     xl4: "3.125 rem",
//   },
// };

// export const sidebarColorScheme = {
//   default: {
//     background: Colors.secondaryscale["100"],
//     font: Colors.secondaryscale["700"],
//   },
//   hovered: {
//     background: Colors.secondaryscale["200"],
//     font: Colors.secondaryscale["700"],
//   },
//   pressed: {
//     background: Colors.secondaryscale["300"],
//     font: Colors.secondaryscale["700"],
//   },
//   selected: {
//     background: Colors.secondaryscale["0"],
//     subpath: Colors.primaryscale["100"],
//     border: Colors.primary,
//     font: Colors.secondaryscale["700"],
//     icon: Colors.primary,
//   },
//   popover: {
//     font: Colors.secondaryscale["700"],
//     divider: Colors.secondaryscale["50"],
//     background: Colors.secondaryscale["0"],
//     title: Colors.primary,
//   },
// };
